import React from "react";
import moment from "moment";
import times from "lodash/times";
import { MenuItem } from "@material-ui/core";
import { Field } from "redux-form/immutable";

import TextField from "app/components/form/TextField";

const MINUTES_PER_HOUR = 60;

const MinutesDropDown = ({ renderTextField, name, ...rest }) => {
  const now = moment({ minutes: 0 });

  return (
    <Field select name={name} component={TextField} label="mm" {...rest}>
      {times(MINUTES_PER_HOUR, minute => (
        <MenuItem key={minute} value={minute}>
          {now
            .clone()
            .add(minute, "minutes")
            .format("mm")}
        </MenuItem>
      ))}
    </Field>
  );
};

export default React.memo(MinutesDropDown);
